import React from 'react'

import SectionContainer from 'components/atoms/SectionContainer'
import RIASECTabs from 'components/organisms/RIASECTabs'

import config from 'config'

const { assets_url: assetsUrl } = config
const aptReportAssetsPath = `${assetsUrl}/assets/img/aptitude/report`

const RIASECExplanation = () => (
  <div className="riasec-explanation">
    <SectionContainer
      paddingBottom={80}
      paddingTop={120}
      backgroundColor="transparent"
    >
      <RIASECTabs fullContent/>
    </SectionContainer>
    <style jsx>
      {`
        .riasec-explanation {
          background-image: url(${aptReportAssetsPath}/rectangle-blue.png);
          background-repeat: no-repeat;
          background-position: top center;
          background-size: contain;
          :global(.cmps-row) {
            grid-gap: 0px;
          }
          :global(.campus-section) {
            @media screen and (max-width: 767px) {
              padding-bottom: 40px;
            }
          }
        }
      `}
    </style>
  </div>
)

export default RIASECExplanation
